<div class="sidenav-wrapper" id="nav-bar">
    <nav class="sidenav">
        <div class="sidemenu-wrapper">
            <div class="menu-container">
                <!-- Organization Dropdowns -->
                <div
                    class="px-4 py-4 mb-2 border-b border-gray-100"
                    *ngIf="user?.user_type === 'ORGANIZATION'"
                >
                    <div class="flex flex-col gap-3">
                        <select
                            id="brandSidenav"
                            [(ngModel)]="selectedBrandId"
                            (ngModelChange)="onBrandChange($event)"
                            class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 shadow-sm"
                        >
                            <option *ngFor="let brand of brands" [value]="brand.id">
                                {{ brand.name }}
                            </option>
                        </select>
                        <select
                            *ngIf="regions.length > 0"
                            id="regionSidenav"
                            [(ngModel)]="selectedRegionId"
                            (ngModelChange)="onRegionChange($event)"
                            class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 shadow-sm"
                        >
                            <option *ngFor="let region of regions" [value]="region.id">
                                {{ region.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <ng-container *ngIf="!activeSubmenu">
                    <ng-container *ngFor="let groupName of groupOrder">
                        <ng-container
                            *ngIf="groupedMenu[groupName] && isGroupVisible(groupedMenu[groupName])"
                        >
                            <!-- Group Title -->
                            <div class="menu-group-title" *ngIf="isCollapsed">{{ groupName }}</div>
                            <div
                                class="menu-group-title collapsed-title text-center pr-2"
                                *ngIf="!isCollapsed"
                            >
                                ---
                            </div>

                            <!-- Group Items -->
                            <ng-container *ngFor="let item of groupedMenu[groupName]">
                                <!-- Standard Item -->
                                <a
                                    *ngIf="!hasChildren(item) && !item.hidden"
                                    [routerLink]="
                                        !item.disabled && !item.openInNewTab ? item.route : null
                                    "
                                    [href]="item.openInNewTab ? item.route : null"
                                    [target]="item.openInNewTab ? '_blank' : undefined"
                                    [class.active]="activeRoute === item.route"
                                    [class.disabled]="item.disabled"
                                    [ngClass]="['sidemenu', item.customClass || '']"
                                    (click)="!item.disabled && setActive(item.route!)"
                                    matTooltip="{{ item.tooltip || '' }}"
                                    [appAuthorize]="item"
                                >
                                    <span class="icon-badge-wrapper">
                                        <i class="fa-solid" [ngClass]="[item.icon, 'fa-xl']"></i>
                                        <span
                                            *ngIf="item.badge"
                                            class="badge"
                                            [ngStyle]="{
                                                backgroundColor: item.badgeColor ?? '#ff4757',
                                            }"
                                            >{{ item.badge }}</span
                                        >
                                    </span>
                                    <span
                                        *ngIf="isCollapsed"
                                        class="sidemenu-name truncate flex-1"
                                        >{{ item.label }}</span
                                    >
                                </a>

                                <!-- Item with Children (Drill-down trigger) -->
                                <a
                                    *ngIf="hasChildren(item) && !item.hidden"
                                    class="sidemenu nested-group cursor-pointer"
                                    [class.parent-active]="getParentActiveState(item)"
                                    [matTooltip]="item.tooltip || ''"
                                    (click)="openSubmenu(item)"
                                    (keydown.enter)="openSubmenu(item)"
                                    tabindex="0"
                                    [appAuthorize]="item"
                                >
                                    <span class="icon-badge-wrapper">
                                        <i class="fa-solid" [ngClass]="[item.icon, 'fa-xl']"></i>
                                        <span
                                            *ngIf="item.badge"
                                            class="badge"
                                            [ngStyle]="{
                                                backgroundColor: item.badgeColor ?? '#ff4757',
                                            }"
                                            >{{ item.badge }}</span
                                        >
                                    </span>
                                    <span
                                        *ngIf="isCollapsed"
                                        class="sidemenu-name truncate flex-1"
                                        >{{ item.label }}</span
                                    >
                                    <i
                                        *ngIf="isCollapsed"
                                        class="fa-solid fa-chevron-right ml-auto text-xs opacity-50 mr-4"
                                    ></i>
                                </a>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </ng-container>

                <!-- DRILL-DOWN VIEW -->
                <ng-container *ngIf="activeSubmenu">
                    <!-- Group Title (replacing Back Button at top) -->
                    <div class="menu-group-title" *ngIf="isCollapsed">
                        {{ activeSubmenu.label }}
                    </div>
                    <div
                        class="menu-group-title collapsed-title text-center pr-2"
                        *ngIf="!isCollapsed"
                    >
                        ---
                    </div>

                    <!-- Submenu Items -->
                    <a
                        *ngFor="let child of activeSubmenu.children"
                        [routerLink]="!child.disabled && !child.openInNewTab ? child.route : null"
                        [href]="child.openInNewTab ? child.route : null"
                        [target]="child.openInNewTab ? '_blank' : undefined"
                        [class.active]="activeRoute === child.route"
                        [class.disabled]="child.disabled"
                        [ngClass]="['sidemenu', child.customClass || '']"
                        (click)="!child.disabled && setActive(child.route!)"
                        matTooltip="{{ child.tooltip || '' }}"
                        [appAuthorize]="child"
                    >
                        <span class="icon-badge-wrapper">
                            <i
                                class="fa-solid"
                                [ngClass]="[child.icon || 'fa-circle-dot', 'fa-xl']"
                            ></i>
                        </span>
                        <span *ngIf="isCollapsed" class="sidemenu-name truncate flex-1">{{
                            child.label
                        }}</span>
                    </a>

                    <!-- Back Button at the bottom -->
                    <a
                        class="sidemenu back-menu-btn cursor-pointer"
                        (click)="closeSubmenu()"
                        (keydown.enter)="closeSubmenu()"
                        tabindex="0"
                    >
                        <span class="icon-badge-wrapper">
                            <i class="fa-solid fa-arrow-left fa-xl"></i>
                        </span>
                        <span *ngIf="isCollapsed" class="sidemenu-name truncate flex-1">Back</span>
                    </a>
                </ng-container>
            </div>
        </div>
    </nav>
</div>
